export default __webpack_public_path__ + "static/media/avatar.e83849d3.svg";